import React from 'react';
import { openConsentSettings, PRIVACY_POLICY_URL, TERMS_URL } from '../lib/consent';
import s from './LegalLinks.module.css';

// The marketing site's two legal pages, as a quiet line of small grey text:
// under the sign-in form (LoginPage, both modes) and at the foot of Business
// Settings. The stores ask for an in-app link to the privacy policy, and the
// phones carry the same pair with the same words
// (android/app/src/main/kotlin/studio/coda/app/ui/LegalFooter.kt,
// ios/CodaStudio/UI/Components/LegalLinks.swift).
//
// "Privacy" and "Terms", the marketing footer's own words. Legal pages only —
// nothing about a plan, a price or billing (App Store guideline 3.1.3(f) is
// why the phones must not, and the words are one set).
//
// A new tab: the pages are on another host, and the form or the settings a
// teacher has half filled in should still be there.
//
// `cookieSettings` adds "Cookie settings", which reopens the cookie banner
// (#755), on the screens outside the app's frame — sign-in, check your email,
// the two thank-you pages — where there is no sidebar to carry
// ConsentSettingsButton and where measurement runs unless the visitor
// declines. Not on Business Settings, whose sidebar has it, and not on the
// phones, which set no cookies. The screen must also render a ConsentBanner,
// which is what the button opens.
export const LEGAL_LINKS = [
  { label: 'Privacy', href: PRIVACY_POLICY_URL },
  { label: 'Terms', href: TERMS_URL },
];

export default function LegalLinks({ className, cookieSettings = false }) {
  return (
    <nav aria-label="Legal" className={className ? `${s.legal} ${className}` : s.legal}>
      {LEGAL_LINKS.map(({ label, href }, i) => (
        <React.Fragment key={href}>
          {i > 0 ? <span className={s.dot} aria-hidden="true">·</span> : null}
          <a className={s.link} href={href} target="_blank" rel="noreferrer">{label}</a>
        </React.Fragment>
      ))}
      {cookieSettings ? (
        <>
          <span className={s.dot} aria-hidden="true">·</span>
          <button type="button" className={`${s.link} ${s.button}`} onClick={openConsentSettings}>
            Cookie settings
          </button>
        </>
      ) : null}
    </nav>
  );
}
